import React, { useState, useEffect } from 'react';
import { Tabs, Dropdown, Pagination } from 'antd';
import { DeleteOutlined, DownOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { clearYourTownloopSearchValue } from '@/store/slices/searchBarSlice';
import { getUserCollectList } from '@/api/products';
import { getSuggestProductList } from '@/api/order';
import { saveUserCollect } from '@/api/products';
import YourTownloopProductList from '../../components/YourTownloopProductList/YourTownloopProductList';
import YourTownloopSuggestList from '../../components/YourTownloopProductList/YourTownloopSuggestList';
import { eventBus } from '@/utils/eventBus';
import styles from './YourFavorites.module.scss';
import icon1 from '@/assets/images/路径 5.png';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

//tabItems切换
const tabItems = [
  { label: 'All', key: 'all' },
  { label: 'list', key: 'list' },
];



const YourFavorites: React.FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  //yourTownloopSearchValue关键字
  const yourTownloopSearchValue = useAppSelector((state) => state.searchBar.yourTownloopSearchValue);

  // 商品推荐
  const [suggestions, setSuggestions] = useState<any[]>([]);

  //商品列表
  const [products, setProducts] = useState([

  ]);

  const [params, setParams] = useState({
    page_num: 1,
    page_size: 10,
    total: 0
  });

  //获取商品id
  const getId = (id: string) => {
    console.log('id', id);
    navigate(`/ProductDetail/${id}`);
  }


  //获取收藏列表
  const getUserCollectListFn = (page_num: number, page_size: number) => {
    getUserCollectList({ page_num, page_size }).then((res) => {
      if (res.code === 200) {
        setProducts(res.data);
        setParams({
          ...params,
          total: res.total
        });
      }
    });
  }

  //tab切换
  const [activeTab, setActiveTab] = useState('all');

  //切换tab事件
  const changeTab = (key: string) => {
    setActiveTab(key);
  }

  //条件查询
  const condition = (key: string) => {
    console.log('condition', key);
  }


  //分页change
  const paginationChange = (page: number, pageSize: number) => {
    console.log('page', page, pageSize);
    setParams({
      ...params,
      page_num: page,
      page_size: pageSize
    });
    getUserCollectListFn(page, pageSize);
  }

  //mounted 和unmounted
  useEffect(() => {
    getUserCollectListFn(params.page_num, params.page_size);

    getSuggestProductList({ num: 5 }).then((res) => {
      if (res.code == 200) {
        console.log(res.data, 'res.data推荐商品');
        setSuggestions(res.data);
      }
    });

    return () => {
      console.log('组件销毁时');
      //销毁清除townloopSearchValue的值
      eventBus.emit('deleteTownloopSearchValue');
      dispatch(clearYourTownloopSearchValue());
    }
  }, []);

  //yourTownloopSearchValue关键字的监听
  useEffect(() => {
    console.log('YourFavorites组件yourTownloopSearchValue', yourTownloopSearchValue);

  }, [yourTownloopSearchValue])


const deleteFavouriteProduct = async (productId: string) => {
  const res = await saveUserCollect({
    product_id: productId,
    is_delete: true,
  })
  if (res.code === 200) {
   getUserCollectListFn(1, params.page_size);

  }
};
  return (
    <div className={styles['favorites-box']}>
      <div className={styles['suggest-title']}>{t("YourFavorites.SuggestedForYou")}</div>
      <YourTownloopSuggestList products={suggestions} getId={getId}></YourTownloopSuggestList>

      <div className={styles['favorites-top-content']}>
        <div className={styles['favorites-text-box']}>
          <div className={styles['favorites-text']}>
            {t("YourFavorites.MyCollection")}
          </div>
        </div>
      </div>
      <YourTownloopProductList
        products={products}
        getId={getId}
        needRenderDelete={true}
        deleteFavouriteProduct={(productId) =>deleteFavouriteProduct(productId)}
      ></YourTownloopProductList>

      <div className={styles['pagination-box']}>
        <Pagination onChange={paginationChange} defaultCurrent={1} total={params.total} />
      </div>
    </div>
  );
};

export default YourFavorites; 